import { Leaf, Truck, Users, ArrowRight, Phone } from "lucide-react";
import noodles from "./images/noodles.png";
import greenchilli from "./images/greencilli.png";
import leaf from "./images/leaf.png";
import leafBlur from "./images/leafblue.png";
import cabageleave from "./images/cabageleave.png";
import { scrollToTop } from "../../utils/index";
import { useEffect } from "react";
import autheticate from "./images/autheticate.png";
import fresh from "./images/fresh.png";
import cozy from "./images/cozy.png";
import CarouselFood from "./CarouselFood";
import box1 from "./images/box1.png";
import box2 from "./images/box2.jpg";
import box3 from "./images/box3.png";
import box4 from "./images/box4.jpg";
import box5 from "./images/box5.png";
import box6 from "./images/box6.png";
import box7 from "./images/box7.jpg";
import box8 from "./images/box8.jpg";

export default function RestaurantComponent() {
  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div
        className="relative px-6 py-16 pb-32"
        style={{ backgroundColor: "rgba(255, 254, 219, 1)" }}
      >
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-800 leading-tight">
              Your Party, Our Flavors -<br />
              Call Now for a Quote!
            </h1>
            <div className="flex flex-wrap gap-4">
              <button className="bg-green-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-green-600 transition-colors flex items-center gap-2">
                <Phone className="w-5 h-5" />
                CALL NOW
              </button>
              <button className="bg-white text-gray-700 px-6 py-3 rounded-full font-bold hover:bg-gray-50 transition-colors flex items-center gap-2 border-2 border-gray-200">
                <Phone className="w-5 h-5" />
                CHECK MENU
              </button>
            </div>
          </div>

          {/* Right Content - Large Food Image */}
          <div className="relative flex justify-center">
            <div className="relative">
              {/* Large Noodle Bowl - Half in bg, half extending below */}
              <div className="w-96 h-96 relative z-10">
                <div className="w-full h-full bg-orange-100 rounded-full flex items-center justify-center border-8 border-white shadow-2xl overflow-hidden">
                  <div className="w-80 h-80 bg-orange-200 rounded-full flex items-center justify-center overflow-hidden">
                    <img
                      className="w-72 h-72 object-cover rounded-full"
                      src={noodles}
                      alt="Delicious Noodles"
                    />
                  </div>
                </div>
              </div>

              {/* Floating leaves around the large bowl */}
              <div className="absolute -top-2 -left-4 w-10 h-10 bg-green-200 rounded-full flex items-center justify-center shadow-lg">
                <Leaf className="w-6 h-6 text-green-600" />
              </div>
              <div className="absolute top-8 -right-6 w-8 h-8 bg-green-300 rounded-full flex items-center justify-center shadow-lg">
                <Leaf className="w-5 h-5 text-green-700" />
              </div>
              <div className="absolute -bottom-4 -left-8 w-12 h-12 bg-green-100 rounded-full flex items-center justify-center shadow-lg">
                <Leaf className="w-7 h-7 text-green-500" />
              </div>
              <div className="absolute bottom-12 -right-2 w-6 h-6 bg-green-200 rounded-full flex items-center justify-center shadow-lg">
                <Leaf className="w-4 h-4 text-green-600" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Promise Section */}
      <div className="py-16 px-6 -mt-16 pt-24">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-12">
            Our Promise to You
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Fresh Ingredients */}
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center">
                <img src={fresh} alt="Fresh Ingredients" className="w-8 h-8" />
              </div>
              <h3 className="text-lg font-semibold text-gray-800">
                Fresh Ingredients
              </h3>
            </div>

            {/* Authentic Flavors */}
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center">
                <img
                  src={autheticate}
                  alt="Authentic Flavors"
                  className="w-8 h-8"
                />
              </div>
              <h3 className="text-lg font-semibold text-gray-800">
                Authentic Flavors
              </h3>
            </div>

            {/* Cozy Ambience */}
            <div className="flex flex-col items-center space-y-4">
              <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center">
                <img src={cozy} alt="Cozy Ambience" className="w-8 h-8" />
              </div>
              <h3 className="text-lg font-semibold text-gray-800">
                Cozy Ambience
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Cozy Ambience Section */}
      <div
        className="py-16 px-6"
        style={{
          background: "linear-gradient(180deg, #B6D8FF 0%, #FFFFFF 100%)",
        }}
      >
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 leading-tight">
              Cozy Ambience,
              <br />
              Unforgettable Flavours
            </h2>
            <p className="text-gray-600 leading-relaxed">
              Step into a warm and inviting space where every corner feels like
              home. From soft lighting, comfortable seating, and soothing music
              set the perfect mood.
            </p>
          </div>

          {/* Right Content - Restaurant Images Grid */}
          <div>
            <CarouselFood />
          </div>
        </div>
      </div>

      {/* Food Gallery Section */}
      <div className="py-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {/* Row 1 - Changed from h-32 to h-48 for larger height */}
            <div className="bg-red-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box1}
                alt="Food 1"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-yellow-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box2}
                alt="Food 2"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-brown-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box3}
                alt="Food 3"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-orange-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box4}
                alt="Food 4"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>

            {/* Row 2 - Changed from h-32 to h-48 for larger height */}
            <div className="bg-red-200 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box5}
                alt="Food 5"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-green-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box6}
                alt="Food 6"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-yellow-200 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box7}
                alt="Food 7"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
            <div className="bg-gray-100 rounded-lg h-52 flex items-center justify-center">
              <img
                src={box8}
                alt="Food 8"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
